import {
  Card,
  Col,
  OverlayTrigger,
  Row,
  Tooltip,
  Spinner
} from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import SoftBadge from 'components/common/SoftBadge';
import IconButton from 'components/common/IconButton';

const ItemKey = ({
  data: { name, status, apiKey, secret, web_hook, time },
  isFirst,
  handleDelete,
  changeStatus,
  isLoading
}) => {
  if (isLoading) {
    return (
      <Spinner
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      />
    );
  }

  return (
    <Card className="bg-white mb-3">
      {isFirst && (
        <Card.Header className="border-bottom">
          <Card.Title>Listado de Claves</Card.Title>
        </Card.Header>
      )}
      <Card.Body>
        <Row>
          <Col xs={12} className="mb-3">
            <h5 className="mb-0">{name}</h5>
          </Col>
          <Col xs={12} sm={6} md={12} lg={6} className="mb-3">
            <h6 className="fs--2 mb-0">API KEY</h6>
            <p className="mb-0">{apiKey}</p>
          </Col>
          <Col xs={12} sm={6} md={12} lg={6} className="mb-3">
            <h6 className="fs--2 mb-0">SECRET</h6>
            <p className="mb-0">{secret}</p>
          </Col>
          <Col xs={12} sm={6} md={12} lg={6} className="mb-3">
            <h6 className="fs--2 mb-0">WEBHOOK</h6>
            <p className="mb-0">{web_hook}</p>
          </Col>
          <Col xs={12} sm={6} md={12} lg={6} className="mb-3">
            <h6 className="fs--2 mb-0">DURACIÓN DEL TOKEN</h6>
            <p className="mb-0">{`${time} horas`}</p>
          </Col>

          <Col xs={12} sm={6} md={12} lg={6}>
            <div
              className="mb-3 d-flex flex-column flex-md-row"
              style={{ gap: '10px' }}
            >
              <SoftBadge
                bg={classNames({
                  success: status === 'active',
                  danger: status === 'inactive'
                })}
                className="fs--1 d-flex align-items-center mb-2 mb-md-0 w-xs-25"
              >
                {status === 'active' ? 'Activa' : 'No activa'}
              </SoftBadge>

              <div className="w-xs-100 mb-2 mb-md-0">
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip>
                      {status === 'active' ? 'Desactivar' : 'Activar'}
                    </Tooltip>
                  }
                >
                  <IconButton
                    onClick={changeStatus}
                    buttonSize="sm"
                    style={{ width: '100%' }}
                    icon={status === 'active' ? 'pause' : 'play'}
                    variant="primary"
                    className="px-2"
                  />
                </OverlayTrigger>
              </div>

              <div className="w-100">
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip>Eliminar</Tooltip>}
                >
                  <IconButton
                    buttonSize="sm"
                    style={{ width: '100%' }}
                    icon="trash-can"
                    onClick={handleDelete}
                    variant="danger"
                    className="px-2"
                  />
                </OverlayTrigger>
              </div>
            </div>

            <style>
              {`
                  @media (min-width: 768px) {
                      .w-100 .px-2 {
                          width: 28px !important;
                          max-width: 28px !important;
                      }
                  }
              `}
            </style>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

ItemKey.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    apiKey: PropTypes.string.isRequired,
    secret: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    web_hook: PropTypes.string.isRequired,
    time: PropTypes.number.isRequired
  }),
  isFirst: PropTypes.bool.isRequired,
  handleDelete: PropTypes.func.isRequired,
  changeStatus: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired
};

export default ItemKey;
